import PropTypes, { element, func } from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
    Card,
    CardBody,
    Col,
    Row,
    Container,
    Badge,
    CardTitle,
    FormGroup,
    Input,
    InputGroup,
    UncontrolledTooltip,
} from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "../../assets/scss/style.css"
// import { Modal, Form, Button } from "react-bootstrap"
import { useFormik } from "formik"
import * as Yup from "yup"

import "flatpickr/dist/themes/material_blue.css"

import { withTranslation } from "react-i18next"

import { apiRoute, BASE_URL } from "routes/apiRoutes"
import axios from "axios"
import { dateformat, dateTimeformat } from "admin/commonFunction"
import Pagination, {
    bootstrap5PaginationPreset,
} from "react-responsive-pagination"
import { erroralert } from "helpers/toast.helper"
import { capitalizeFirstLetter, makeShortNumber } from "helpers/helper"
import Modal from 'react-bootstrap/Modal';

const Transaction = props => {

    document.title = "Auction"
    const [dateFilter, setDateFilter] = useState([])
    const [listingData, setData] = useState([])
    const [offerData, setOfferData] = useState([])
    const [searchName, setSearchName] = useState("")
    const [statusFilter, setStatusFilter] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [loaderStatus, setLoaderStatus] = useState(true)
    let [incermentInd, setIncrementInd] = useState(1)
    const perPage = 15

    const [modalShow, setModalShow] = useState(false);
    const handleShow = () => setModalShow(!modalShow);

    //fetch users
    const fetchData = async (pagenumber, pagelimit, searchName = "") => {
        try {

            let res = await axios.get(
                apiRoute.getNFTList + `?page=${pagenumber}&limit=${pagelimit}&keyword=${searchName}`
            )
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                console.log(res.data.data['docs']);
                setData(res.data.data['docs'])

                let pageCount = Math.ceil(res.data.data.totalDocs / perPage)
                setTotalCount(pageCount)
            }
        } catch (err) {
            // console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
        }
    }


    useEffect(() => {
        fetchData(currentPage, perPage)
    }, [])

    const handlePageClick = page => {
        setCurrentPage(page)
        fetchData(page, perPage, searchName)
    }

    let [timer, setTimer] = useState(null);
    const handleSearchClick = event => {
        setSearchName(event.target.value)
        setCurrentPage(1)

        clearTimeout(timer)
        let value = setTimeout(() => {
            fetchData(1, perPage, event.target.value)
        }, 200);
        setTimer(value);
    }

    const getTotalOffer = async (id) => {

        try {

            let res = await axios.get(
                apiRoute.getItemOffer + `?page=1&limit=1000000&item_id=${id}&type=item`
            )
            if (res?.data?.status == false) {
                throw new Error(res?.data?.message)
            } else {
                console.log(res.data.data['docs'], '<<----------------offer');
                setOfferData(res.data.data['docs'])
                handleShow();
            }
        } catch (err) {
            console.log(err.message, "<<--")
            erroralert(err)
        } finally {
            setLoaderStatus(false)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody className="border-bottom py-2">
                                    <div className="d-flex align-items-center">
                                        <h5 className="mb-0 card-title flex-grow-1">
                                            {" "}Auction{" "}
                                        </h5>

                                        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
                                            <div
                                                className="position-relative"
                                                style={{ marginTop: "10px" }}
                                            >
                                                <label htmlFor="search-bar-0" className="search-label">
                                                    <span id="search-bar-0-label" className="sr-only">
                                                        Search this table
                                                    </span>
                                                    <input
                                                        id="search-bar-0"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={`Search Name...`}
                                                        onChange={handleSearchClick}
                                                    />
                                                </label>
                                                <i className="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardBody>
                                    <Table
                                        id="tech-companies-1"
                                        className="table table-striped table-bordered"
                                    >
                                        <Thead>
                                            <Tr>
                                                <Th>Image</Th>
                                                <Th>Collection Name</Th>
                                                <Th>NFT Name</Th>
                                                <Th>Owner</Th>
                                                <Th>Minimum Price</Th>
                                                <Th>Wallet Address</Th>
                                                <Th>Total Offer</Th>
                                                <Th>Description</Th>
                                                <Th>Created Date</Th>
                                                <Th>Status</Th>
                                                <Th>Action</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {loaderStatus ? (
                                                <Tr className="d-none">
                                                    <Td colSpan="6"> Loading ... </Td>
                                                </Tr>
                                            ) : listingData?.length != 0 ? (
                                                listingData?.map((element, index) => {
                                                    return (
                                                        (element?.is_auction) &&
                                                        <tr key={index}>
                                                            <td>
                                                                <img src={`${BASE_URL}/images/collection/logo/${element?.collection_id?.image}`} alt="" className="rounded-circle avatar-xs" />
                                                            </td>
                                                            <td>{element?.collection_id?.name}</td>
                                                            <td>{element?.name}</td>
                                                            <td>{element?.current_owner?.username}</td>
                                                            <td>{makeShortNumber(element?.price)} ETH</td>
                                                            <td>-</td>
                                                            <td>{element?.offers?.length}</td>
                                                            <td>{element?.description}</td>
                                                            <td>{dateformat(element?.create_date)}</td>
                                                            <td>{capitalizeFirstLetter(element?.status)}</td>
                                                            <td>
                                                                <div className="d-flex gap-3 align-items-center">
                                                                    {
                                                                        <Link
                                                                            to="#"
                                                                            className="text-primary"
                                                                            onClick={() => getTotalOffer(element?._id)}
                                                                        >
                                                                            <i className="mdi mdi-eye font-size-20" id="deletetooltip" />
                                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                                See Offers
                                                                            </UncontrolledTooltip>
                                                                        </Link>
                                                                    }

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={12} style={{ textAlign: "center" }}>
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}
                                        </Tbody>
                                    </Table>

                                    <Row className="mt-2">
                                        <Col md={9}></Col>
                                        <Col md={3}>
                                            <Pagination
                                                {...bootstrap5PaginationPreset}
                                                current={currentPage}
                                                total={totalCount}
                                                onPageChange={page => handlePageClick(page)}
                                                className="pagination justify-content-end"
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>


            <Modal show={modalShow} onHide={handleShow} backdrop="static" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Offers</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Table
                        id="tech-companies-1"
                        className="table table-striped table-bordered"
                    >
                        <Thead>
                            <Tr>
                                <Th>Image</Th>
                                <Th>Item Name</Th>
                                <Th>Price</Th>
                                <Th>Status</Th>
                                <Th>Sender name</Th>
                                <Th>Reciever name</Th>
                                <Th>Created Date</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {loaderStatus ? (
                                <Tr className="d-none">
                                    <Td colSpan="6"> Loading ... </Td>
                                </Tr>
                            ) : offerData?.length != 0 ? (
                                offerData?.map((element, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <img src={`${BASE_URL}/images/collection/logo/${element?.item_id?.thumb}`} alt="" className="rounded-circle avatar-xs" />
                                            </td>
                                            <td>{element?.item_id?.name}</td>
                                            <td>{makeShortNumber(element?.item_id?.price)} ETH</td>
                                            <td>{capitalizeFirstLetter(element?.status)}</td>
                                            <td>{element?.sender?.username}</td>
                                            <td>{element?.receiver?.username}</td>
                                            <td>{dateformat(element?.create_date)}</td>
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan={12} style={{ textAlign: "center" }}>
                                        No Records Found
                                    </td>
                                </tr>
                            )}
                        </Tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}


export default Transaction
